// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file aggregate/v1/aggregate_api.proto (package aggregate.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetCompanyProjectAggregateUsersRequest, GetCompanyProjectAggregateUsersResponse, GetCompanyProjectsAggregateRequest, GetCompanyProjectsAggregateResponse, GetCompanyProjectsTasksAggregateRequest, GetCompanyProjectsTasksAggregateResponse, GetCompanyUserAndProjectsRequest, GetCompanyUserAndProjectsResponse, GetUserAggregateProfileRequest, GetUserAggregateProfileResponse } from "./aggregate_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * AggregateAPI service
 *
 * @generated from service aggregate.v1.AggregateAPI
 */
export const AggregateAPI = {
  typeName: "aggregate.v1.AggregateAPI",
  methods: {
    /**
     * @generated from rpc aggregate.v1.AggregateAPI.GetUserAggregateProfile
     */
    getUserAggregateProfile: {
      name: "GetUserAggregateProfile",
      I: GetUserAggregateProfileRequest,
      O: GetUserAggregateProfileResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc aggregate.v1.AggregateAPI.GetCompanyProjectAggregateUsers
     */
    getCompanyProjectAggregateUsers: {
      name: "GetCompanyProjectAggregateUsers",
      I: GetCompanyProjectAggregateUsersRequest,
      O: GetCompanyProjectAggregateUsersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc aggregate.v1.AggregateAPI.GetCompanyProjectsAggregate
     */
    getCompanyProjectsAggregate: {
      name: "GetCompanyProjectsAggregate",
      I: GetCompanyProjectsAggregateRequest,
      O: GetCompanyProjectsAggregateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc aggregate.v1.AggregateAPI.GetCompanyProjectsTasksAggregate
     */
    getCompanyProjectsTasksAggregate: {
      name: "GetCompanyProjectsTasksAggregate",
      I: GetCompanyProjectsTasksAggregateRequest,
      O: GetCompanyProjectsTasksAggregateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc aggregate.v1.AggregateAPI.GetCompanyUserAndProjects
     */
    getCompanyUserAndProjects: {
      name: "GetCompanyUserAndProjects",
      I: GetCompanyUserAndProjectsRequest,
      O: GetCompanyUserAndProjectsResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

